import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import PopoverHeader from './PopoverHeader'
import { connect } from 'react-redux'
import { RadioGroup } from 'wix-style-react'
import { setCustomFieldArray } from 'controllers/logic'

const Container = styled.div`
  _height: 26em;
  width: 20em;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  border-radius: 8px;
  box-shadow: 0 4px 10px 8px rgba(175,175,175,0.27);
`
const TypeContainer = styled.div`
  height: 100%;
  color: #000;
  font-size: 12px;
  background: #fff;
  padding: 3px 10px;
  border-radius: 10px;
  
  span {
    font-size: 14px;
    display: block;
    margin-bottom: 10px;
  }
`

const Content = styled.div`
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  display: flex;
  flex-direction: column;
`

class CustomButtonPopover extends Component {

  constructor (props) {
    super(props)

    this.state = {
      activeRadio: ''
    }
  }

  componentWillMount () {
    this.props.updatePosition('15%', '45%')
    this.setState({
      activeRadio: this.props.value
    })
  }

  onInputChange = (e) => {
    const { value } = e.target
    const { app, dispatch, path } = this.props
    if (path) {
      dispatch(setCustomFieldArray(app.id, path, value))
    }
  }

  renderContent () {
    return (
      <div>No settings for this field type</div>
    )
  }

  renderTypeChooser () {
    const { app, dispatch, path } = this.props
    const onChange = (val) => {
      this.setState({
        activeRadio: val
      })
      if (path) {
        dispatch(setCustomFieldArray(app.id, [path[0], 'buttonFieldType'], val))
      }
    }
    return (
      <TypeContainer>
        <span>Choose Field type:</span>
        <RadioGroup value={this.state.activeRadio} onChange={val => onChange(val)} display='horizontal'>
          <RadioGroup.Radio value={'button'}>Button</RadioGroup.Radio>
          <RadioGroup.Radio value={'appLinks'}>App Links</RadioGroup.Radio>
        </RadioGroup>
      </TypeContainer>

    )
  }

  render () {
    const { app, field, closeMyself } = this.props
    return (
      <Container>
        <PopoverHeader
          headingDescriptor='Custom Button Settings'
          onClose={closeMyself}
          app={app}
          helpTooltip=''
          field={field}
        />
        <Content>
          {this.renderTypeChooser()}
        </Content>
      </Container>
    )
  }
}

CustomButtonPopover.propTypes = {
  closeMyself: PropTypes.func,
  value: PropTypes.string,
  path: PropTypes.array,
  // title: PropTypes.string,
  field: PropTypes.object.isRequired,
  app: PropTypes.object.isRequired,
  updatePosition: PropTypes.func,
}

export default connect()(CustomButtonPopover)



// WEBPACK FOOTER //
// ./src/components/editor/popovers/CustomButtonPopover.js